<app-devices-tab
  [itemCollection]="itemObservable"
  [buttonActive]="false"
  [deviceNavigate]="true"
  [title]="title"
  (itemNavigate)="navigate($event)"
  [deviceSettings]="deviceSettings"
  [loading]="loadingChildren"
></app-devices-tab>
